import React from 'react';
import { IAuditoriaContasPagarReceberResultado } from '../interfaces/IAuditoriaContasPagarReceber';
import { TributoAuditoria } from '../interfaces/IAuditoria';
import { formatCurrency } from '../utils/formatters';

interface Props {
  resultado?: IAuditoriaContasPagarReceberResultado;
  onSelecionar: (tributo: TributoAuditoria) => void;
}


// Auditoria de Contas a Pagar e a Receber (Fornecedores e Clientes) — verifica se o saldo final
// de contas de Fornecedores (Passivo) ou Clientes (Ativo) fechou com a natureza invertida.
const AuditoriaResumoContasPagarReceber: React.FC<Props> = ({ resultado, onSelecionar }) => {
  if (!resultado) {
    return null;
  }

  const totalOcorrencias = resultado.contasComNaturezaInvertida?.length || 0;

  return (
    <div className='auditoria-card mt-5'>
      <h3>Resumo de Contas a Pagar e a Receber</h3>
      <p className='text-muted'>
        Auditoria complementar — contas de Fornecedores (Passivo) ou Clientes (Ativo) que fecharam o período com a
        natureza do saldo invertida, indicando erro de classificação contábil. Clique para ver a análise detalhada.
      </p>

      <div className='table-responsive mt-4'>
        <table className='auditoria-table auditoria-table-tributos'>
          <thead>
            <tr>
              <th>Auditoria</th>
              <th className='text-end'>Impacto Fiscal Estimado</th>
              <th className='text-center'>Erros</th>
              <th className='text-center'>Avisos</th>
              <th className='text-center'>Alertas</th>
            </tr>
          </thead>

          <tbody>
            <tr className='auditoria-row-tributo' onClick={() => onSelecionar('AUDITORIA_CONTAS_PAGAR_RECEBER')}>
              <td className='auditoria-col-tributo'>
                <div className='d-flex align-items-center gap-2'>
                  <strong>Auditoria de Contas a Pagar e a Receber</strong>
                  <span className={`auditoria-status status-${resultado.status}`}>
                    {resultado.status}
                  </span>
                </div>
                <div className='auditoria-legislacao-inline'>
                  <div>{totalOcorrencias} conta{totalOcorrencias === 1 ? '' : 's'} com natureza invertida identificada{totalOcorrencias === 1 ? '' : 's'} no período</div>
                  <div className='text-muted'>{resultado.mensagemDirecionamento}</div>
                </div>
              </td>
              <td className='text-end auditoria-col-highlight'>
                {formatCurrency(resultado.impactoFiscalTotal)}
                <div className='auditoria-kpi-help'>Multa ECD potencial — 5% limitada a 1% da receita bruta do período (Art. 12, II, Lei 8.218/1991)</div>
              </td>
              <td className='text-center'>
                <span className='auditoria-contador auditoria-contador-erro'>{resultado.totalErros}</span>
              </td>
              <td className='text-center'>
                <span className='auditoria-contador auditoria-contador-aviso'>{resultado.totalAvisos}</span>
              </td>
              <td className='text-center'>
                <span className='auditoria-contador auditoria-contador-alerta'>{resultado.totalAlertas}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AuditoriaResumoContasPagarReceber;
